//Please add the language resource
const importTemplateSettings = {
  templateCode: '模版编号',
  templateName: '模版名称',
  shipperName: '货主',
  templateTypeName: '模板类型',
  isDefault: '是否默认',
  remark: '备注',
  clientColumnName: '客户模版名称',
  systemColumnId: '系统ID',
  dataType: '数据类型',
  isRequired: '是否必填',
  columnDesc: '列格式说明',
  defaultValue: '默认值',
  sortOrder: '排序号',
  showFlag: '是否显示',
  msg: {
    templateName: '请输入模版名称',
    shipperCode: '请选择货主',
    templateTypeCode: '请选择模版类型',
    startRow: '请输入起始行数',
    isDefault: '请选择是否默认'
  }
};
export default importTemplateSettings



// WEBPACK FOOTER //
// ./src/page/configurationCenter/importTemplateSettings/lang/importTemplateSettings.en.js